import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { useEffect, useState } from 'react';

type OnboardingWrapperProps = {
  children?: JSX.Element;
  error?: string | null;
};

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '8% 20%',
  },
  alert: {
    top: 0,
    position: 'absolute',
  },
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '7% 30%',
  },
  greetingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    textAlign: 'center',
  },
  greeting: {
    fontSize: '27px',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  physiotherapy: {
    fontSize: '17px',
    color: '#171717 87%',
    marginTop: '20px',
    textAlign: 'center',
  },
  childrenContainer: {
    marginTop: '60px',
    width: '100%',
  },
}));

export const OnboardingWrapper: React.FC<OnboardingWrapperProps> = ({
  children,
  error,
}) => {
  const classes = useStyles();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (error) {
      setShowAlert(true);
    }
  }, [error]);

  return (
    <div className={classes.container}>
      <Paper className={classes.paper}>
        {showAlert && (
          <Alert
            severity="error"
            className={classes.alert}
            onClose={() => setShowAlert(false)}>
            {error}
          </Alert>
        )}
        <div className={classes.greetingWrapper}>
          <Typography className={classes.greeting}>Welcome to</Typography>
          <Typography className={classes.greeting}>Halterix PT+</Typography>
        </div>
        <Typography className={classes.physiotherapy}>
          Data-Driven Physical Therapy
        </Typography>
        <div className={classes.childrenContainer}>{children}</div>
      </Paper>
    </div>
  );
};
